
import { Component, Vue } from 'vue-property-decorator';
import OsCampaignForm from '@/components/shared/campaigns/OsCampaignForm.vue';
import { ICampaign, Recipientgroup, FormOfAddress } from '@/models/application';
import OsSheet from '@/components/core/sheet/OsSheet.vue';
import OsSheetContent from '@/components/core/sheet/OsSheetContent.vue';
import { GuidUtil } from '@/utils/GuidUtil';
import { customersApi } from '@/apis';
import { AppDirtyUtil } from '@/utils/AppDirtyUtil';
import OsSubMenuPage from '@/layouts/pages/OsSubMenuPage.vue';

@Component({
  components: {
    OsSubMenuPage,
    OsSheetContent,
    OsSheet,
    OsCampaignForm
  }
})
export default class CampaignCreate extends Vue {
  appDirtyUtil: AppDirtyUtil = new AppDirtyUtil();

  campaign: ICampaign = {
    id: GuidUtil.empty(),
    customerId: GuidUtil.empty(),
    questionnaireId: null,
    title: '',
    recipientgroup: Recipientgroup.All,
    participantReportEmailTemplateId: null,
    formOfAddress: FormOfAddress.Formal
  };

  loading = false;
  customerId!: string;

  created() {
    this.customerId = this.$route.params.id;
  }

  async onSave() {
    this.loading = true;
    try {
      this.campaign.customerId = this.customerId;
      const result = await customersApi.createCampaign(
        this.customerId,
        this.campaign
      );
      this.appDirtyUtil.init(this.campaign);
      await this.$router.push(
        `/customers/${this.customerId}/campaigns/` + result.id
      );
    } finally {
      this.loading = false;
    }
  }
}
